module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6n5r9n3n-dd8cc4abc277c557dfbee26e7bca3ba2.svg";